<div class="flex flex-col gap-[0.5rem]">
  <div class="text-[0.75rem] font-[600] leading-[150%] text-(--p-primary-400)" translate="@@shared-comment-label"></div>
  @let lastSavedComment = lastSavedValue();

  @if (formGroup) {
    <form [formGroup]="formGroup" class="flex flex-col gap-[0.5rem]">
      @let isMessageEmpty = !lastSavedComment && !formGroup.get('comment')?.value;
      @let editVisible = isEditVisible();
      @let textAreaFocused = isFocused();

      <div class="flex flex-col p-[0.75rem] border-[1px] rounded-[0.5rem] border-(--p-primary-50)"
        [ngClass]="{
          'border-(--p-red-500) shadow-[0px_1px_0.5rem_0px_var(--p-other-opacity-red-20)]': !isMessageEmpty && formGroup.touched && formGroup.invalid && editVisible,
          'border-(--p-surface-300) shadow-[0px_1px_0.5rem_0px_var(--p-other-opacity-sky-20)]': (!formGroup.invalid && (editVisible || textAreaFocused)) || (!lastSavedComment && textAreaFocused),
        }"
      >

        <textarea
          pTextarea
          [autoResize]="true"
          [placeholder]="'@@edit-comment-placeholder' | translate"
          formControlName="comment"
          name="comment"
          (focus)="isFocused.set(true)"
          (blur)="isFocused.set(false)"
          class="placeholder:!text-(--p-gray-300)
           placeholder:!text-[0.75rem]
           placeholder:!font-[500]
           !border-0 !p-0 !shadow-none
           !outline-none !rounded-none
           !bg-transparent w-full
           resize-none min-h-[5.625rem]
           !text-[0.75rem] !font-[600]
           !leading-[150%]
           text-(--p-gray-950)
           disabled:!opacity-100
           disabled:!text-[0.75rem]
           disabled:!font-[600]
           disabled:!text-(--p-gray-950)
           disabled:!cursor-default"
        ></textarea>
        <div class="flex items-center justify-between gap-[0.75rem] pt-[0.75rem]">
          <div>
            @let showSavedMessage = showSuccessMessage() && !showSuccessMessageNotNeeded();

            @if (showSavedMessage && lastSavedComment === formGroup.get('comment')?.value) {
              <div class="text-(--p-other-green-500) flex flex-row gap-[0.25rem] items-center">
                <svg-icon src="icons/icon-check.svg"
                  name="icon-check"
                  svgClass="!size-[1.25rem]">
                </svg-icon>
                <div class="text-[0.75rem] font-[600] leading-[150%]" translate="@@edit-comment-successfully-saved"></div>
              </div>
            }
          </div>
          <div class="flex items-center min-h-[2.375rem] gap-1">
            @if (editVisible) {
              @if (!isMessageEmpty) {
                <p-button [label]="'@@shared-cancel__text' | translate"
                  styleClass="!p-[0.375rem_1rem_0.5rem_1rem] text-[0.75rem] font-[600]"
                  [outlined]="true"
                  (onClick)="cancel()"/>

                <p-button [label]="'@@shared-save' | translate"
                  styleClass="!p-[0.375rem_1rem_0.5rem_1rem] text-[0.75rem] font-[600]"
                  [disabled]="formGroup.invalid || lastSavedComment === formGroup.get('comment')?.value" (onClick)="submit()"/>
              }
            } @else {
              <p-button [label]="'@@shared-edit' | translate"
                styleClass="!p-[0.375rem_1rem_0.5rem_1rem] text-[0.75rem] font-[600]"
                (onClick)="activateEditView()"/>
            }
          </div>
        </div>
      </div>

      @if (!isMessageEmpty && editVisible && formGroup.get('comment')?.hasError('maxlength')) {
        <div
          class="text-[0.75rem] font-[500] leading-[150%] pb-[1.25rem] text-(--p-red-500)"
          translate="@@edit-comment-characters-error"
          [translateParams]="{
            I18N_VAR_MAX: maxCommentsLength
          }">
        </div>
      } @else {
        <div
          class="text-[0.75rem] font-[500] leading-[150%] pb-[1.25rem] text-(--p-gray-500)"
          translate="@@edit-comment-characters"
          [translateParams]="{
            I18N_VAR_CURRENT: formGroup.get('comment')?.value?.length || 0,
            I18N_VAR_MAX: maxCommentsLength
          }">
        </div>
      }
    </form>
  }
</div>


